// @flow
export const validateEmail = (email: String) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}
export const validate = (values: Object = {}) => {
  const errors = {}
  const { member = {}, guarantor = {}, partner = {} } = values
  const errorMember = {}
  if (!values.paymentPlan) {
    errors.paymentPlan = 'Oh, you need to complete this information here'
  }
  if (values.terms !== true) {
    errors.terms = 'Oh, you need to accept the terms here in order to continue'
  }
  if (member.phoneNumber === '+') {
    errorMember['phoneNumber'] = 'Oh, you need to enter your phone number here'
  }
  if (!member.gender) {
    errorMember['gender'] = 'Oh, you need to select your gender here'
  }
  if (!values.isStudent) {
    errors.isStudent = 'Oh, you need to select one option here'
  }
  if (!values.paymentMethod) {
    errors.paymentMethod = 'Oh, you need to select a payment method'
  }
  if (!member.nationality) {
    errorMember['nationality'] = 'Oh, you need to select your nationality status here'
  }
  if (!member.citizenship) {
    errorMember['citizenship'] = 'Oh, you need to select your citizenship status here'
  }
  if (member.email && !validateEmail(member.email)) {
    errorMember['email'] = 'Oh, you need to enter a valid email address'
  }
  if (partner && partner.email === member.email) {
    errors.partner = { email: 'Partner cannot share email with member' }
    errorMember['email'] = 'Member cannot share email with partner'
  }
  if (guarantor && partner && guarantor.email === partner.email) {
    errors.guarantor = { email: 'Guarantor cannot share email with partner' }
    errors.partner = { email: 'Partner cannot share email with guarantor' }
  }
  if (guarantor && guarantor.email === member.email) {
    errors.guarantor = { email: 'Guarantor cannot share email with member' }
    errorMember['email'] = 'Member cannot share email with guarantor'
  }
  errors['member'] = errorMember
  return errors
}



// WEBPACK FOOTER //
// ./src/containers/SecureRoom/validationHelper.js